import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ReactSVG from 'react-svg';
import classnames from 'classnames';
import {notifyError} from "./Notifications";

const ProductCartButton = ({ cartCount = 0, isSticky, onClick }) => {

  const [ runAnimation, setRunAnimation ] = useState(false);
  const [ hasBeenClicked, setHasBeenClicked ] = useState(false);

  useEffect(() => {
    setRunAnimation(false);
    setTimeout(() => setRunAnimation(true), 100);
  }, [ cartCount ]);

  const classes = classnames('btn', 'cart-btn', {
    'sticky-btn': isSticky
  });

  const animationClasses = classnames({
    count: true,
    animated: true,
    bounce: runAnimation
  });

  const onBtnClick = () => {
    setHasBeenClicked(true);
    if (cartCount > 0){
      onClick();
    } else {
      notifyError('cartEmpty');
    }
  }

  return <button className={ classes } onClick={onBtnClick} disabled={!cartCount && hasBeenClicked}>
    <ReactSVG src="/classpath/assets/images/header-cart.svg" wrapper="span" />
    <FormattedMessage id='cart' />
    <span className={ animationClasses }>{ cartCount }</span>
  </button>;
};

export default ProductCartButton;
